import Blue from "../core";

new Blue({
	name: 'Product Header Media Toggle',
	selector: ".product-header__media",
	setup(container) {
		const display = container.querySelector(".product-header__display-img");
		const thumbnails = [...container.querySelectorAll("img.product-header__thumbnail")];
		
		if (!!thumbnails.length) {
			const parent = container.querySelector(".product-header__thumbnails");
			parent.classList.add("scrolled-left");

			// Determine if thumbnail is visible or needs to be scrolled into view
			const isVisible = (i, diff) => {
				let testImg = thumbnails[i + diff];
				if (!testImg) return true;
				else {
					let distToParentRightEdge = parent.offsetWidth + parent.getBoundingClientRect().left;
					let distToParentLeftEdge = parent.getBoundingClientRect().left;
					let imgLeft = testImg.getBoundingClientRect().left;
					let imgRight = testImg.getBoundingClientRect().right;
					return imgLeft > distToParentLeftEdge - 4 && imgRight < distToParentRightEdge + 4;
				};
			}

			// handler when img thumbnail is clicked
			const toggleImg = index => {
				container.querySelector(".product-header__thumbnail.active")?.classList.remove("active");
				display.setAttribute("src", thumbnails[index].getAttribute("src"));
				display.setAttribute("alt", thumbnails[index].getAttribute("alt"));
				thumbnails[index].classList.add("active");
				let parentWidth = parent.offsetWidth;
				let parentScrollWidth = parent.scrollWidth;
				if (parentScrollWidth > parentWidth) {
					if (!isVisible(index, 1)) {
						let right = thumbnails[index + 1].getBoundingClientRect().right - (parent.offsetWidth + parent.getBoundingClientRect().left);
						parent.scroll({left: parent.scrollLeft + right, behavior: 'smooth'})
					}
					if (!isVisible(index, -1)) {
						let left = parent.getBoundingClientRect().left - thumbnails[index - 1].getBoundingClientRect().left;
						parent.scroll({left: parent.scrollLeft - left, behavior: 'smooth'})
					}
				}
			}

			// set scrolled classes to add visual cue to user that thumbnail container can be scrolled
			const setScrollClasses = () => {
				let parentScroll = parent.scrollLeft;
				// console.log("scroll:", parentScroll)
				// console.log("scroll:", parent.scrollWidth - parent.offsetWidth)
				if (parentScroll > (parent.scrollWidth - parent.offsetWidth - 8)) {
					parent.classList.remove("scrolled-left");
				}
			}
			this.$addEvents(parent, "scroll", setScrollClasses)

			// Set display image to first thumbnail on page load
			toggleImg(0);

			// Add toggle event listeners
			thumbnails.forEach((thumbnail, i) => {
				this.$addEvents(thumbnail, "click enter", (e) => {
					if (!e.target.matches(".active"))	toggleImg(i)
				});
			});
			
			// Once initial image is loaded into display, add loaded class to actually show image
			display.classList.add("loaded");
		}
	}
});

new Blue({
	name: 'Product Header Type Toggle',
	selector: ".product-header",
	setup(container) {
		const typeTextContainers = [...container.querySelectorAll(".product-header__type")];
		const typeOptionToggles = [...container.querySelectorAll(".product-header__option")];
		const ctaContainers = [...container.querySelectorAll(".product-header__cta-option")];
		const toggleType = index => {
			container.querySelector(".product-header__type.active")?.classList.remove("active");
			container.querySelector(".product-header__option.active")?.classList.remove("active");
			container.querySelector(".product-header__cta-option.active")?.classList.remove("active");
			typeTextContainers[index].classList.add("active");
			ctaContainers[index].classList.add("active");
			typeOptionToggles[index].classList.add("active");
		}
		// Select first product type on page load
		toggleType(0);
		// Add toggle event listeners
		typeOptionToggles.forEach((toggle, i) => {
			this.$addEvents(toggle, "click enter", (e) => {
				if (!e.target.matches(".active"))	toggleType(i);
			});
		});
	}
});
